import { Injectable } from '@angular/core';
import { AlertComponent } from './alert.component';

@Injectable({
  providedIn: 'root'
})
export class AlertService {
  private alertComponent?: AlertComponent;

  add(alertComponent: AlertComponent) {
    this.alertComponent = alertComponent;
  }

  showAlert(type: string, message: string) {
    console.log(`[showAlert] [this.alertComponent=${this.alertComponent}]`)
    this.alertComponent?.showAlert(type, message)
  }

  hideAlert() {
    this.alertComponent?.hideAlert();
  }
}
